"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileToBase64 = FileToBase64;
exports.base64ImageToBlob = base64ImageToBlob;
exports.convertTagsToQueryParams = exports.storeImageFromUrl = exports.convertUriToFile = exports.tryResolveImageToBlob = exports.getSizesForUploadedImages = exports.unsplashCallBack = exports["default"] = exports.isMobileMode = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _fetch = _interopRequireDefault(require("@eig-builder/core-utils/fetch"));

var _imageProxyHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/image-proxy-helper"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _wordpressHelper = require("@eig-builder/core-utils/helpers/wordpress-helper");

var _config = require("../config");

var _storeServiceUrlHelper = _interopRequireDefault(require("./store-service-url-helper"));

var _authUploadHelper = _interopRequireDefault(require("./auth-upload-helper"));

var _useResponsiveQuery = _interopRequireDefault(require("@eig-builder/core-utils/hooks/useResponsiveQuery"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isMobileMode = function isMobileMode() {
  return window.innerWidth <= _useResponsiveQuery["default"].TABLET;
};

exports.isMobileMode = isMobileMode;

var ImageLibraryHelper = /*#__PURE__*/function () {
  function ImageLibraryHelper() {
    (0, _classCallCheck2["default"])(this, ImageLibraryHelper);
  }

  (0, _createClass2["default"])(ImageLibraryHelper, null, [{
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(query, page, amount) {
        var returnOnlyUrls,
            url,
            response,
            data,
            dataToJson,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                returnOnlyUrls = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
                url = "".concat(_config.FETCH_IMAGES_ENDPOINT, "?query=").concat(query, "&page=").concat(page, "&per_page=").concat(amount, "&client_id=98823feb68c3cd3b6c9495406a9d76630c3ab384108542847d37f9278e66dd0e");
                _context.next = 4;
                return (0, _fetch["default"])(url, {
                  method: 'GET',
                  simpleCall: true
                });

              case 4:
                response = _context.sent;
                _context.next = 7;
                return response;

              case 7:
                data = _context.sent;
                _context.next = 10;
                return data.json();

              case 10:
                dataToJson = _context.sent;

                if (!returnOnlyUrls) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", dataToJson.photos.map(function (data) {
                  return data.urls.full;
                }));

              case 13:
                return _context.abrupt("return", dataToJson.results);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function search(_x, _x2, _x3) {
        return _search.apply(this, arguments);
      }

      return search;
    }() // 'https://api.unsplash.com/users'

  }, {
    key: "author",
    value: function () {
      var _author2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_author, page, amount) {
        var returnOnlyUrls,
            url,
            response,
            data,
            dataToJson,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                returnOnlyUrls = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
                url = "".concat(_config.FETCH_AUTHORS_ENDPOINT, "/").concat(_author, "/photos?page=").concat(page, "&per_page=").concat(amount, "&client_id=98823feb68c3cd3b6c9495406a9d76630c3ab384108542847d37f9278e66dd0e");
                _context2.next = 4;
                return (0, _fetch["default"])(url, {
                  method: 'GET',
                  simpleCall: true
                });

              case 4:
                response = _context2.sent;
                _context2.next = 7;
                return response;

              case 7:
                data = _context2.sent;
                _context2.next = 10;
                return data.json();

              case 10:
                dataToJson = _context2.sent;

                if (!returnOnlyUrls) {
                  _context2.next = 13;
                  break;
                }

                return _context2.abrupt("return", dataToJson.photos.map(function (data) {
                  return data.urls.full;
                }));

              case 13:
                return _context2.abrupt("return", dataToJson);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function author(_x4, _x5, _x6) {
        return _author2.apply(this, arguments);
      }

      return author;
    }()
  }, {
    key: "deleteMyImages",
    value: function () {
      var _deleteMyImages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(images) {
        var tokenFromAuthCheck, body, response, data, toJson;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _authUploadHelper["default"].checkAuth();

              case 3:
                tokenFromAuthCheck = _context3.sent;
                body = images.length > 1 ? {
                  image_ids: images
                } : {
                  image_id: images[0]
                };
                _context3.next = 7;
                return window.fetch(_storeServiceUrlHelper["default"].getUrl('upload'), {
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer ".concat(tokenFromAuthCheck)
                  },
                  body: JSON.stringify(body)
                });

              case 7:
                response = _context3.sent;
                _context3.next = 10;
                return response;

              case 10:
                data = _context3.sent;
                _context3.next = 13;
                return data.json();

              case 13:
                toJson = _context3.sent;
                return _context3.abrupt("return", toJson);

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", Error(_context3.t0));

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 17]]);
      }));

      function deleteMyImages(_x7) {
        return _deleteMyImages.apply(this, arguments);
      }

      return deleteMyImages;
    }()
  }, {
    key: "getWordPressImages",
    value: function () {
      var _getWordPressImages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(siteId) {
        var areWeWordpress, tokenFromAuthCheck, imageTokenHeader;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                areWeWordpress = (0, _wordpressHelper.checkIsWordpress)();

                if (areWeWordpress) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return", []);

              case 3:
                _context5.next = 5;
                return _authUploadHelper["default"].checkAuth();

              case 5:
                tokenFromAuthCheck = _context5.sent;
                imageTokenHeader = new window.Headers({
                  Authorization: "Bearer ".concat(tokenFromAuthCheck)
                });
                return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(resolve, reject) {
                    var apiUrl, wordpressData, data, dataJson;
                    return _regenerator["default"].wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.prev = 0;
                            apiUrl = (0, _urlHelper.api)("/v1.0/plugin/".concat(siteId, "/images"), 'wordpress');
                            _context4.next = 4;
                            return (0, _fetch["default"])(apiUrl, {
                              method: 'GET',
                              headers: imageTokenHeader
                            });

                          case 4:
                            wordpressData = _context4.sent;
                            _context4.next = 7;
                            return wordpressData;

                          case 7:
                            data = _context4.sent;
                            _context4.next = 10;
                            return data.json();

                          case 10:
                            dataJson = _context4.sent;
                            resolve((dataJson || []).map(function (x) {
                              return {
                                image_id: x.id,
                                account_id: null,
                                hash: x.url,
                                file_name: x.name,
                                thumbnail: x.thumbnail,
                                image_uri: x.url,
                                modified: x.date,
                                original_url: x.url
                              };
                            }));
                            _context4.next = 17;
                            break;

                          case 14:
                            _context4.prev = 14;
                            _context4.t0 = _context4["catch"](0);
                            reject(_context4.t0);

                          case 17:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, null, [[0, 14]]);
                  }));

                  return function (_x9, _x10) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function getWordPressImages(_x8) {
        return _getWordPressImages.apply(this, arguments);
      }

      return getWordPressImages;
    }()
  }]);
  return ImageLibraryHelper;
}();

exports["default"] = ImageLibraryHelper;

var unsplashCallBack = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(_ref2) {
    var downloadLocation, response;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            downloadLocation = _ref2.downloadLocation;

            if (!downloadLocation) {
              _context6.next = 6;
              break;
            }

            _context6.next = 4;
            return (0, _fetch["default"])("".concat(downloadLocation).concat(downloadLocation.includes('?') ? '&' : '?', "client_id=98823feb68c3cd3b6c9495406a9d76630c3ab384108542847d37f9278e66dd0e"), {
              method: 'GET',
              simpleCall: true
            });

          case 4:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 6:
            return _context6.abrupt("return", null);

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function unsplashCallBack(_x11) {
    return _ref3.apply(this, arguments);
  };
}();

exports.unsplashCallBack = unsplashCallBack;

var getSizesForUploadedImages = function getSizesForUploadedImages() {
  var sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.SIZES;
  var originalUrl = arguments.length > 1 ? arguments[1] : undefined;
  return _config.SIZES.map(function (size) {
    return (0, _defineProperty2["default"])({}, size, new _imageProxyHelper["default"](originalUrl).resize("".concat(size, "x").concat(size)).result());
  }).reduce(function (initial, next) {
    var key = Object.keys(next)[0];
    return _objectSpread(_objectSpread({}, initial), {}, (0, _defineProperty2["default"])({}, key, next[key]));
  }, {});
};

exports.getSizesForUploadedImages = getSizesForUploadedImages;

var tryResolveImageToBlob = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(uri) {
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", new Promise(function (resolve, reject) {
              var newImage = new window.Image();
              newImage.crossOrigin = 'anonymous';
              newImage.src = uri;

              newImage.onload = function () {
                var canvas = document.createElement('canvas');
                canvas.width = newImage.width;
                canvas.height = newImage.height;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(newImage, 0, 0);
                canvas.toBlob(function (blob) {
                  resolve(blob);
                });
              };

              newImage.onerror = function (e) {
                resolve({
                  error: e
                });
              };
            }));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function tryResolveImageToBlob(_x12) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * Give it a url and it will return a File object
 * It recreated an external URL to a canvas -> blob -> File
 */


exports.tryResolveImageToBlob = tryResolveImageToBlob;

var convertUriToFile = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(uri) {
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(resolve, reject) {
                var fileName, proxyUrl, resolvedBlob, blob, contentType, extension;
                return _regenerator["default"].wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!(typeof uri !== 'string')) {
                          _context8.next = 2;
                          break;
                        }

                        return _context8.abrupt("return", Error('Url has to be a string'));

                      case 2:
                        fileName = (uri.split('/').pop() || 'uploaded-file').replace(/[^a-z0-9]/gi, '_').replace(/_+/gi, '_').split('#')[0].split('?')[0].substring(0, 50);
                        proxyUrl = _imageProxyHelper["default"].getProxyUrl(uri);
                        _context8.next = 6;
                        return tryResolveImageToBlob(proxyUrl);

                      case 6:
                        resolvedBlob = _context8.sent;

                        if (resolvedBlob && resolvedBlob.error) {
                          resolve({
                            error: resolvedBlob.error
                          });
                        } else {
                          blob = resolvedBlob;
                          contentType = blob.type;

                          if (!_config.EXT_ALLOWED.indexOf(contentType.toLowerCase()) === -1) {
                            contentType = 'image/jpeg';
                          }

                          extension = _config.FILE_EXT_MAPPING[contentType];
                          resolve(new window.File([blob], "".concat(fileName, ".").concat(extension), {
                            type: contentType
                          }));
                        }

                      case 8:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              }));

              return function (_x14, _x15) {
                return _ref7.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function convertUriToFile(_x13) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * Stores an image on the server from an url
 * @param {*} url - The url to the external image
 */


exports.convertUriToFile = convertUriToFile;

var storeImageFromUrl = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(url, file, query) {
    var serverUrl, tokenFromCheckAuth, response, data, newData;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            serverUrl = _storeServiceUrlHelper["default"].getUrl('uploadFromUrl');
            _context10.next = 3;
            return _authUploadHelper["default"].checkAuth();

          case 3:
            tokenFromCheckAuth = _context10.sent;
            _context10.next = 6;
            return (0, _fetch["default"])("".concat(serverUrl, "/?").concat(query), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer ".concat(tokenFromCheckAuth)
              },
              credentials: 'include',
              simpleCall: true,
              body: JSON.stringify({
                url: url,
                filename: file
              })
            });

          case 6:
            response = _context10.sent;
            _context10.next = 9;
            return response;

          case 9:
            data = _context10.sent;
            _context10.next = 12;
            return data.json();

          case 12:
            newData = _context10.sent;
            return _context10.abrupt("return", newData);

          case 14:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function storeImageFromUrl(_x16, _x17, _x18) {
    return _ref8.apply(this, arguments);
  };
}();
/**
 * Converts a File to a base64 (async)
 * @param {*} file - File
 */


exports.storeImageFromUrl = storeImageFromUrl;

function FileToBase64(_x19) {
  return _FileToBase.apply(this, arguments);
}
/**
 * Converts a base64 string to a Blob
 * @param {} str base64 string
 */


function _FileToBase() {
  _FileToBase = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(file) {
    var TempFileReader;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            TempFileReader = new FileReader();
            return _context11.abrupt("return", new Promise(function (resolve, reject) {
              TempFileReader.onError = function () {
                TempFileReader.abort();
                reject(new Error('error reading from file'));
              };

              TempFileReader.onload = function () {
                resolve(TempFileReader.result);
              };

              TempFileReader.readAsDataURL(file);
            }));

          case 2:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _FileToBase.apply(this, arguments);
}

function base64ImageToBlob(str) {
  // extract content type and base64 payload from original string
  var pos = str.indexOf(';base64,');
  var type = str.substring(5, pos);
  var b64 = str.substr(pos + 8); // decode base64

  var imageContent = window.atob(b64); // create an ArrayBuffer and a view (as unsigned 8-bit)

  var buffer = new ArrayBuffer(imageContent.length);
  var view = new Uint8Array(buffer); // fill the view, using the decoded base64

  for (var n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  } // convert ArrayBuffer to Blob


  var blob = new Blob([buffer], {
    type: type
  });
  return blob;
}
/*
Tags come in the following form:

tags: [
  {
    key: 'siteId',
    value: <siteId>
  }
]
*/


var convertTagsToQueryParams = function convertTagsToQueryParams() {
  var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if ((0, _typeof2["default"])(tags) === 'object') {
    return Object.keys(tags).map(function (key) {
      return "".concat(key, "=").concat(tags[key]);
    }).join('&');
  }
};

exports.convertTagsToQueryParams = convertTagsToQueryParams;